import { DeliverableTask, Platform } from '../constants/campaign';
import {
    ICampaignDeliverables,
    ICampaignDetails,
    ITemplate,
} from '../interfaces/campaign.interface';

export const setTemplateDetailsInCampaign = (
    campaign: ICampaignDetails,
    organizationTemplates: ITemplate[],
) => {
    const updatedCampaign: ICampaignDetails = { ...campaign };
    const deliverables = updatedCampaign.deliverables.map((deliverable) => {
        const updatedDeliverable: ICampaignDeliverables = { ...deliverable };
        if (
            updatedDeliverable.task === DeliverableTask.RESIZE &&
            deliverable.platform === Platform.CUSTOM
        ) {
            const regex = /(\d+)\s*px\s*x\s*(\d+)\s*px/;
            const match = updatedDeliverable.content.match(regex);
            if (match) {
                updatedDeliverable.width = parseInt(match[1], 10);
                updatedDeliverable.height = parseInt(match[2], 10);
            } else {
                updatedDeliverable.width = 100;
                updatedDeliverable.height = 100;
            }
        } else if (updatedDeliverable.task === DeliverableTask.VARIANT) {
            const regex = /(\d+)\.\s*(.*)/;
            const match = updatedDeliverable.content.match(regex);
            if (match) {
                updatedDeliverable.variant_count = parseInt(match[1], 10);
                updatedDeliverable.content = match[2];
            } else {
                updatedDeliverable.variant_count = 1;
            }
        }

        if (updatedDeliverable.sub_deliverable) {
            updatedDeliverable.ad_product_photo = undefined;
            updatedDeliverable.user_product_path = '';
            updatedDeliverable.templateDetails = null;
        } else {
            if (
                organizationTemplates &&
                organizationTemplates.length > 0 &&
                updatedDeliverable.template
            ) {
                const searchedTemplate = organizationTemplates.find((template) => {
                    return template.id === updatedDeliverable.template;
                });
                updatedDeliverable.templateDetails = searchedTemplate ? searchedTemplate : null;
            } else {
                updatedDeliverable.templateDetails = null;
            }
        }
        return updatedDeliverable;
    });
    updatedCampaign.deliverables = deliverables;
    return updatedCampaign;
};
